var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaBlueIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02525 14.0729C1.17236 14.9616 1.94453 15.6394 2.875 15.6394H14.125C15.1605 15.6394 16 14.7999 16 13.7644V10.1926M1.02525 14.0729C1.00864 13.9725 1 13.8695 1 13.7644V2.5144C1 1.47887 1.83947 0.639404 2.875 0.639404H14.125C15.1605 0.639404 16 1.47887 16 2.5144V10.1926M1.02525 14.0729L4.60715 10.491C5.24468 9.93314 6.17705 9.87206 6.88191 10.342L7.35921 10.6602C8.0386 11.1131 8.93298 11.0743 9.57058 10.5642L12.0532 8.57808C12.686 8.07185 13.5674 8.03213 14.2401 8.46605C14.3147 8.51414 14.381 8.5737 14.4438 8.63644L16 10.1926M7.5625 5.3269C7.5625 6.36244 6.72303 7.2019 5.6875 7.2019C4.65197 7.2019 3.8125 6.36244 3.8125 5.3269C3.8125 4.29137 4.65197 3.4519 5.6875 3.4519C6.72303 3.4519 7.5625 4.29137 7.5625 5.3269Z",
    stroke: "#123051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaBlueIcon);
export default __webpack_public_path__ + "static/media/mediaBlueIcon.f7be26bf7069db12aa5af3b73d7dd28b.svg";
export { ForwardRef as ReactComponent };